import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getFaasApiUrl = createConfigSelector('faasApiUrl');

export const getLoginUrl = createConfigSelector('loginUrl');

export const getNewDomainUrl = createConfigSelector('newDomainUrl');

export const getCulinaryCollectiveFlags = createConfigSelector(
  'culinaryCollectiveEnabled'
);

export const getCenturionNetworkFlags = createConfigSelector(
  'centurionNetworkEnabled'
);

export const getProxyUrl = createConfigSelector('proxyUrl');

export const getEnabledMarkets = createConfigSelector('enabledMarkets');
